import { render } from "./cdn-svg.vue?vue&type=template&id=5f81b7ba&lang=pug"
import script from "./cdn-svg.vue?vue&type=script&lang=js"
export * from "./cdn-svg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__